export default (microservice) => {
  const { protocol } = window.location;
  const dommen = window.location.hostname.slice(window.location.hostname.lastIndexOf('.'));

  if (process.env.NODE_ENV === 'development' || window.location.host.includes('bookimed.loc')) {
    return `https://${microservice}.bookimed.run/`;
  }
  return `${protocol}//${microservice}.bookimed${dommen}/`;
};
